import { getSeatMapApi } from '../../services/api/search.service';
import { selectAccessToken } from '../selectors/auth.selector';
import { selectTripResults } from '../selectors/search.selector';
import { selectTripSummary, selectTravelCart } from '../selectors/trip.selector';

export const SET_SEATMAP = 'SET_SEATMAP';
export const SELECT_SEAT = 'SELECT_SEAT';
export const SELECT_SEAT_REBOOK = 'SELECT_SEAT_REBOOK';
export const SELECT_SEAT_EVENTS = 'SELECT_SEAT_EVENTS';
export const UNSELECT_SEAT = 'UNSELECT_SEAT';
export const UNSELECT_SEAT_REBOOK = 'UNSELECT_SEAT_REBOOK';
export const UNSELECT_SEAT_EVENTS = 'UNSELECT_SEAT_EVENTS';
export const SET_ACTIVE_SEGMENT = '[seat] SET_ACTIVE_SEGMENT';
export const CLEAR_SEAT_SELECTED = 'CLEAR_SEAT_SELECTED';

export const selectSeat = (seat, airSegmentId, passengerIndex, classOfService) => {
  return async (dispatch) => {
    dispatch({
      type: SELECT_SEAT,
      seat,
      airSegmentId,
      passengerIndex,
      classOfService,
    });
  };
};

export const selectSeatRebook = (seat, airSegmentId, passengerName, classOfService) => {
  return async (dispatch) => {
    dispatch({
      type: SELECT_SEAT_REBOOK,
      seat,
      airSegmentId,
      passengerName,
      classOfService,
    });
  };
};
export const selectSeatEvents = (seat, airSegmentId, passengerName, classOfService) => {
  return async (dispatch) => {
    dispatch({
      type: SELECT_SEAT_EVENTS,
      seat,
      airSegmentId,
      passengerName,
      classOfService,
    });
  };
};

export const unselectSeat = (seat, airSegmentId, passengerIndex, classOfService) => {
  return async (dispatch) => {
    dispatch({
      type: UNSELECT_SEAT,
      seat,
      airSegmentId,
      passengerIndex,
      classOfService,
    });
  };
};
export const unselectSeatRebook = (seat, airSegmentId, passengerName, classOfService) => {
  return async (dispatch) => {
    dispatch({
      type: UNSELECT_SEAT_REBOOK,
      seat,
      airSegmentId,
      passengerName,
      classOfService,
    });
  };
};
export const unselectSeatEvents = (seat, airSegmentId, passengerName, classOfService) => {
  return async (dispatch) => {
    dispatch({
      type: UNSELECT_SEAT_EVENTS,
      seat,
      airSegmentId,
      passengerName,
      classOfService,
    });
  };
};

export const setActiveSegment = (segmentId) => {
  return { type: SET_ACTIVE_SEGMENT, segmentId };
};

export const getSeatMap = (segment) => {
  return async (dispatch, getState) => {
    const state = getState();
    const accessToken = selectAccessToken(state);
    const results = selectTripResults(state);
    const tripSummaryData = selectTripSummary(state);
    const airResponses = tripSummaryData.AirResponses;
    const airResponse = airResponses && airResponses[0];
    const travelCart = selectTravelCart(state);

    const tempPassengerList = travelCart.Passengers.map((p) => ({
      Name: p.FirstName,
      SeatNumber: '',
      Price: '',
    }));

    const seatMapRQ = {};
    seatMapRQ.departureAirport = segment.DepartureAirportCode;
    seatMapRQ.arrivalAirport = segment.ArrivalAirportCode;
    seatMapRQ.journeyDate = segment.DepartureDate;
    seatMapRQ.flightNumber = segment.FlightNumber;
    seatMapRQ.ServiceClass = segment.ResBookDesigCode;
    seatMapRQ.MarketingAirlineCode = segment.AirlineCode;
    seatMapRQ.Pnr = '';
    seatMapRQ.gdsSourceKey = airResponse.SourceID;
    seatMapRQ.tripID = '0';
    seatMapRQ.airSegmentID = segment.SegmentId;
    seatMapRQ.seatNumber = 'Request Seat';
    seatMapRQ.segmentNumber = segment.SegmentOrder;
    seatMapRQ.legNumber = segment.LegNumber;
    seatMapRQ.isSelectable = true;
    seatMapRQ.ArrivalDate = segment.ArrivalDate;
    seatMapRQ.ArrivalTime = segment.ArrivalTime;
    seatMapRQ.OperatingAirlineCode = segment.AirlineCode;
    seatMapRQ.OperatingFlightNumber = segment.OperatedFlightNumber;
    seatMapRQ.cabin = segment.Cabin;
    seatMapRQ.AirLineName = segment.AirlineName;
    seatMapRQ.DepartDate = segment.DepartureDate;
    seatMapRQ.DepartTime = segment.DepartTime;
    seatMapRQ.TravelRequestId = results.TravelRequestId;
    seatMapRQ.Passengers = tempPassengerList;
    seatMapRQ.SeatsPrice = 0;
    seatMapRQ.IsRedeeem = false;
    seatMapRQ.IsSeatFail = false;
    seatMapRQ.PolicyKey = tripSummaryData?.PolicyKey;

    if (travelCart.FrequentFlyers && travelCart.FrequentFlyers.length) {
      const airLoyaltyNumber = travelCart.FrequentFlyers.filter(
        (x) => x.AirLineCode === seatMapRQ.MarketingAirlineCode
      );
      seatMapRQ.AdvantageNo =
        (airLoyaltyNumber && airLoyaltyNumber[0] && airLoyaltyNumber[0].ProgramNo) || '';
    }

    const seatMap = await getSeatMapApi(accessToken, seatMapRQ);
    dispatch({
      type: SET_SEATMAP,
      airSegmentId: segment.SegmentId,
      seatMap,
    });
  };
};

export const clearSeatSelected = () => {
  return { type: CLEAR_SEAT_SELECTED };
};
